class AppConfig {
  constructor() {}

  getBaseUrl() {
    return process.env.REACT_APP_API_BASE_URL || "http://localhost:3001";
  }

  getVersionHistoryConfig() {
    return {
      pageNumber: 1,
      pageSize: 10000,
    };
  }
}

const appConfig = new AppConfig();

export default appConfig;
